module.exports = __webpack_public_path__ + "static/OTPMobile-7421a190e1fb385f56f78d46f0cf7c59.png";